export default __webpack_public_path__ + "static/media/markerI_online.b0588a8e.svg";